// extracted by mini-css-extract-plugin
module.exports = {"fields":"extendCampaign_fields__Kkg_t","field":"extendCampaign_field__d0di_","label":"extendCampaign_label__EXa_m","alert":"extendCampaign_alert__xu5hq"};